import type { FaireProductEntity } from "../../entity_types/product";

export const p_bmhrauddug: FaireProductEntity = {
  token: "p_bmhrauddug",
  type: "product",
  name: "POG Salt Water Taffy",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/ff6e2d5444043a747d3a227f72d2a40ff71c1c9750b860ac9948004b839b5686.jpeg",
  priceDollars: 5.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
